
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import vSelect from "vue-select";

@Component({
  components: { vSelect },
})
export default class SelectAutocompleteField extends Vue {
  @Prop() field?: any;
  @Prop() fieldName?: string;
  private selectedValue = "";


  get sortedOptions() {
    let filteredOptions = this.field?._displayValues || [];

    //removes options that are marked as former
    filteredOptions = filteredOptions.filter((option) => {
      if (!option.label.includes('(former)')) {
        return option
      }
    });

    return [...(filteredOptions || [])].sort((a, b) => {
      const labelA = a.label?.toString().toLowerCase() || "";
      const labelB = b.label?.toString().toLowerCase() || "";
      return labelA.localeCompare(labelB);
    });
  }

  @Watch("selectedValue")
  onSelectedValueChange(value: string, oldValue: string) {
    this.$emit("input", value);
  }

  removeDiacritics(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  filterBy(option, label, search) {
    const searchLabel = this.removeDiacritics(label);
    const searchValue = this.removeDiacritics(search);
    return (searchLabel || '').toLocaleLowerCase().indexOf(searchValue.toLocaleLowerCase()) > -1;
  }
}
